import React from 'react';
import cn from 'classnames';
import { Row, Col } from 'antd';
import { Button, ButtonProps } from '@base/lib/Button';
import { IAddCartInstance } from '@base/product/useAddCart';
import Message from '@base/lib/Message';
import { canAddToCart, canBuyNow } from 'base/utils/product';
import { getModuleCode } from 'base/utils/features';
import Tracker from '@base/lib/Tracker';
import { useTrans } from 'base/utils/i18n';

type ProdBtnsProps = {
    addCart: IAddCartInstance;
    onSuccess?: () => void;
    className?: string;
    btnAddCartProps?: ButtonProps;
    btnBuyNowProps?: ButtonProps;
    btnSoldOutProps?: ButtonProps;
};

const ProdBtns: React.FC<ProdBtnsProps> = props => {
    const {
        addCart,
        onSuccess,
        className,
        btnAddCartProps,
        btnBuyNowProps,
        btnSoldOutProps,
    } = props;

    const {
        onSubmit,
        submitting,
        onBuyNow,
        buyNowLoading,
        outOfStock,
        disableBuyNow,
        shownVariant,
        trackModuleId,
    } = addCart;

    const moduleCode = trackModuleId ? getModuleCode({ moduleId: trackModuleId }) : void 0;
    const { t } = useTrans();

    const handleSubmit = async () => {
        try {
            await onSubmit();
            onSuccess?.();
        } catch (err: any) {
            if (err?.message) {
                Message.error(err.message);
            }
        }
    };


    return outOfStock ? (
        <Button
            block
            disabled
            type="primary"
            className={className}
            {...btnSoldOutProps}
        >
            {t('web_product_sold_out_upper')}
        </Button>
    ) : (
        <Row gutter={11} data-t-mod={moduleCode}>
            {canAddToCart(shownVariant) && (
                <Tracker async data={!moduleCode ? void 0 : {
                    module: moduleCode,
                    targetType: 'other',
                    target: `${shownVariant.variantTrackCode}.addToCart`,
                    relTarget: `${shownVariant.variantTrackCode}.addToCart`,
                }}>
                    <Col span={disableBuyNow ? 24 : 12}>
                        <Button
                            block
                            type={'d'}
                            tabIndex={0}
                            loading={submitting}
                            onClick={handleSubmit}
                            className={cn(className, 'g-btn-add')}
                            {...btnAddCartProps}
                        >
                            {t('web_product_add_to_cart')}
                        </Button>
                    </Col>
                </Tracker>
            )}

            {!disableBuyNow && canBuyNow(shownVariant) && (
                <Tracker async data={!moduleCode ? void 0 : {
                    module: moduleCode,
                    targetType: 'other',
                    target: `${shownVariant.variantTrackCode}.buyNow`,
                    relTarget: `${shownVariant.variantTrackCode}.buyNow`,
                }}>
                    <Col span={12}>
                        <Button
                            tabIndex={0}
                            block
                            type="primary"
                            onClick={onBuyNow}
                            loading={buyNowLoading}
                            className={cn(className, 'g-btn-buy-now')}
                            {...btnBuyNowProps}
                        >
                            {t('web_product_buy_now')}
                        </Button>
                    </Col>
                </Tracker>
            )}
        </Row>
    )
};

export default ProdBtns;